import { UserRole } from '@shared/utils/base-auth';
import { ShareTypeModel } from '@shared/utils/list-officer';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { IntrensicOfficerBaseResponse } from '@intrensic/shared/officer-details';

export class AgencyOfficerDetailsPermissions {
  constructor(public agencyOfficerDetails: AgencyOfficerDetails, public agencyOfficerPermissions: OfficerPermissions) {}
}

export class AgencyOfficerDetails {
  constructor(
    public timeZone: string,
    public createdOn: string,
    public phone: string,
    public role: UserRole,
    public shareType: ShareTypeModel,
    public respondTo: IntrensicOfficerBaseResponse,
    public children: string | null,
    public firstName: string,
    public lastName: string,
    public employeeID: string,
    public emailAddress: string,
    public pictureFullPath: string | null,
    public timezone: string | null,
    public uid: string
  ) {}
}

export class OfficerPermissions {
  constructor(public canDownloadFiles: boolean, public canUploaderAccess: boolean, public canWebAccess: boolean, public isDisabled: boolean) {}
}
